<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Typical app/web toolbar" />
    <vc-toolbar>
      <vc-toolbar-icon-left icon="menu" @click="onLeftIconClick" />
      <vc-toolbar-title>My App</vc-toolbar-title>
      <vc-toolbar-controls-right>
        <vc-button color="primary" icon-button>
          <vc-icon>fa-twitter</vc-icon>
        </vc-button>
        <vc-button color="primary" icon-button>
          <vc-icon>fa-facebook</vc-icon>
        </vc-button>
        <vc-button color="primary" icon-button>
          <vc-icon>mdi-wordpress</vc-icon>
        </vc-button>
        <vc-button color="primary" icon-button>
          <vc-icon>home</vc-icon>
        </vc-button>
      </vc-toolbar-controls-right>
    </vc-toolbar>
    <example-title src="example-2.html" title="Fully loaded toolbar with title, left and right icons, left and right controls" />
    <vc-toolbar color="deep-purple">
      <vc-toolbar-icon-left icon="menu" @click="onLeftIconClick" />
      <vc-toolbar-controls-left>
        <vc-button color="yellow" :dark="false" icon-button>
          <vc-icon>mdi-wordpress</vc-icon>
        </vc-button>
        <vc-button color="yellow" :dark="false" icon-button>
          <vc-icon>home</vc-icon>
        </vc-button>
      </vc-toolbar-controls-left>
      <vc-toolbar-title>My App</vc-toolbar-title>
      <vc-toolbar-controls-right>
        <vc-button color="green" icon-button>
          <vc-icon>fa-twitter</vc-icon>
        </vc-button>
        <vc-button color="green" icon-button>
          <vc-icon>fa-facebook</vc-icon>
        </vc-button>
      </vc-toolbar-controls-right>
      <vc-toolbar-icon-right icon="home" @click="onRightIconClick" />
    </vc-toolbar>
    <example-title src="example-3.html" title="Narrow toolbar" />
    <vc-toolbar color="pink" narrow>
      <vc-toolbar-icon-left icon="mdi-lastfm" @click="onLeftIconClick" />
      <vc-toolbar-title>My App</vc-toolbar-title>
      <vc-toolbar-controls-right>
        <vc-button color="transparent" icon-button>
          <vc-icon>mdi-rewind</vc-icon>
        </vc-button>
        <vc-button color="transparent" icon-button>
          <vc-icon>mdi-stop</vc-icon>
        </vc-button>
        <vc-button color="transparent" icon-button>
          <vc-icon>mdi-play</vc-icon>
        </vc-button>
        <vc-button color="transparent" icon-button>
          <vc-icon>mdi-fast-forward</vc-icon>
        </vc-button>
      </vc-toolbar-controls-right>
    </vc-toolbar>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ToolbarPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onLeftIconClick () {
      console.log('vc-toolbar-icon-left:click')
    },
    onRightIconClick () {
      console.log('vc-toolbar-icon-right:click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/toolbar.vue